import { forgotPassword, useAppDispatch } from "@vv/state";
import { ROUTES } from "@vv/types";
import { AuthFormCard, AuthShell, Button, Input, showToast } from "@vv/ui";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useState, type FormEvent } from "react";
import { Link as RouterLink } from "react-router-dom";
import { getErrorMessage } from "../../lib/error-message";

export function ForgotPasswordPage() {
  const dispatch = useAppDispatch();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    try {
      await dispatch(forgotPassword({ email })).unwrap();
      showToast("Reset instructions sent", "success");
      setSubmitted(true);
    } catch (err) {
      showToast(getErrorMessage(err, "Could not send reset instructions"), "error");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthShell>
      <AuthFormCard
        title="Forgot password"
        subtitle="We'll email you instructions to reset it"
        footer={
          <Typography variant="body2" color="text.secondary" align="center">
            <Link component={RouterLink} to={ROUTES.login}>
              Back to sign in
            </Link>
          </Typography>
        }
      >
        {submitted ? (
          <Typography variant="body2">
            If that email exists, we&apos;ve sent reset instructions.
          </Typography>
        ) : (
          <Stack spacing={2} component="form" onSubmit={handleSubmit}>
            <Input
              label="Email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
            <Button type="submit" variant="contained" size="large" loading={submitting}>
              Send reset instructions
            </Button>
          </Stack>
        )}
      </AuthFormCard>
    </AuthShell>
  );
}
